<template>
  <div class="table-settings">
    <div
      class="highlight-info-container"
      style="display: flex; gap: 24px; margin-bottom: 32px;"
    >
      <VPTicketSalesMetric
        class="bg-orange-200"
        :title="$gettext('Sales')"
        :today="totalTicketsSalesToday"
        :total="totalSales"
        :percent="salesPercentage"
      />
      <VPTicketSalesMetric
        class="bg-rose-200"
        :title="$gettext('Tickets Sold')"
        :today="totalTicketsSoldToday"
        :total="ticketsSold"
        :percent="ticketsPercentage"
      />
    </div>
    <div>
      <VPEventsTable />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue';
import { useEventStore } from '@/stores/event';
import VPEventsTable from '@/components/events-table/VPEventsTable.vue';
import VPTicketSalesMetric from '@/components/form/VPTicketSalesMetric.vue';
import { formatCurrency } from '@/helpers/currency';
import { useGettext } from 'vue3-gettext';

const { $gettext } = useGettext();

const eventsStore = useEventStore();

onMounted(() => {
  eventsStore.fetchAggregatedEventSales();
});

const totalSales = computed(() => formatCurrency(eventsStore.aggregatedEventSales.salesData.totalSales, { onZero: 0 }));
const ticketsSold = computed(() => String(eventsStore.aggregatedEventSales.salesData.ticketsSold));
const totalTicketsSalesToday = computed(() => formatCurrency(eventsStore.aggregatedEventSales.salesData.totalTicketsSalesToday, { onZero: 0 }));
const totalTicketsSoldToday = computed(() => String(eventsStore.aggregatedEventSales.salesData.totalTicketsSoldToday));
const salesPercentage = computed(() => Number(eventsStore.salesPercentage.toFixed(1)));
const ticketsPercentage = computed(() => Number(eventsStore.ticketsPercentage.toFixed(1)));
</script>
